import React, { useContext, useEffect, useMemo, useState } from 'react'
import srpBg1 from '../../assets/images/srp-bg.webp';
import srpBg2 from '../../assets/images/srp-img2.png';
import srpBg3 from '../../assets/images/srp-img3.png';
import { useLocation } from 'react-router-dom';
import { VehicleContext } from '../Context/VehicleContext';
import { getImages } from '../Common/const';
import InventoryList from '../Components/Inventory/InventoryList';
import ModalLayout from '../Common/ModalLayout';
import SelectFilterModal from '../Components/Inventory/SelectFilterModal';
import MoreFilterModal from '../Components/Inventory/MoreFilterModal';
import SeoMeta from '../Common/SeoMeta';
const images = [srpBg1];
const Inventory = ({ typeFilter, certified }) => {

    const location = useLocation();
    const { vehicleData,
        filteredVehicleData, numberFormatter,
        priceFormatter, currentFilterData,
        setCurrentFilterData,
        priceFilterData,
        mileageFilterData,
        setPriceFilterData,
        setMileageFilterData,
        certifiedFilter,
        setCertifiedFilter,
        searchText,
        setSearchText,
        getVehicleData,
        locationFilters,
        setLocationFilters
    } = useContext(VehicleContext);
    const searchInputChanged = (val) => {
        setSearchText(val);
    }
    useEffect(() => {
        getVehicleData();
    }, []);
    const [bgImage, setBgImage] = useState("");

    const queryParameters = useMemo(() => new URLSearchParams(location.search), [location.search]);

    useEffect(() => {

        const vehicleMake = queryParameters.get("make");
        const vehicleModel = queryParameters.get("model");

        if (vehicleMake) {

            const filter_data = currentFilterData.make.map((v, i) => {
                return v.name.toLowerCase() == vehicleMake.toLowerCase() ? { ...v, "isSelected": true } : { ...v, "isSelected": false };
            });

            //console.log("setting current filters vehicleMake");
            setCurrentFilterData({ ...currentFilterData, ["make"]: filter_data });

        }

        if (vehicleModel) {

            const filter_data = currentFilterData.model.map((v, i) => {
                return v.name.toLowerCase() == vehicleModel.toLowerCase() ? { ...v, "isSelected": true } : { ...v, "isSelected": false };
            });

            //console.log("setting current filters vehicleModel");
            setCurrentFilterData({ ...currentFilterData, ["model"]: filter_data });

        }
    }, [queryParameters, vehicleData]);

    const [filerOptionsOpen, setFilerOptionsOpen] = useState(false);
    const handleMobFilterBtn = () => {
        setFilerOptionsOpen(true)
    }
    const closeSrpFilter = () => {
        setFilerOptionsOpen(false)
    }

    // Filter Modal
    const [openFilterModal, setOpenFilterModal] = useState(false);
    const [filterData, setFilterData] = useState("");
    const [activeFilter, setActiveFilter] = useState("");
    const handleFilterModal = (field) => {
        setOpenFilterModal(true);
        setFilterData(currentFilterData[field]);
        setActiveFilter(field);
    }
    const closeMakeModal = () => {
        setOpenFilterModal(false)
    }
    const updateFilter = (filter_data) => {
        //console.log("setting current filters updateFilter");
        setCurrentFilterData({ ...currentFilterData, [activeFilter]: filter_data });
    }

    const clearFilter = (field) => {
        //console.log(field,currentFilterData,currentFilterData[field],locationFilters);

        const filter_data = [];

        if (currentFilterData[field]) currentFilterData[field].forEach((v) => {
            filter_data.push({ ...v, isSelected: false })
        });

        //console.log("setting current filters clearFilter");
        setCurrentFilterData({ ...currentFilterData, [field]: filter_data });
    }

    //console.log(currentFilterData);

    const clearAllFilters = () => {
        handlePriceSliderChange([priceFilterData.min, priceFilterData.max]);
        handleMileageSliderChange([mileageFilterData.min, mileageFilterData.max]);   

        setCurrentFilterData(prevfilters => {
            const filter_data = {};
            
            Object.keys(prevfilters).map((field) => {
                filter_data[field] = [];
                prevfilters[field].forEach((v) => {
                    filter_data[field].push({ ...v, isSelected: false })
                });
            });

            //console.log("setting current filters clearAllFilters",filter_data);

            return filter_data;

        });

        setLocationFilters(["Tampa, FL", "San Clemente, CA"]);

        setCertifiedFilter(false);
    }

    const srpExitFilters = () => {
        handlePriceSliderChange([priceFilterData.min, priceFilterData.max]);
        handleMileageSliderChange([mileageFilterData.min, mileageFilterData.max]);

        console.log(currentFilterData);

        const filters_present = Object.values(currentFilterData).some((filters) => filters.some((filter) => filter.isSelected));
        //Object.values(currentFilterData).some((field) => currentFilterData[field].isSelected);        

        //console.log("filter test",filters_present,currentFilterData);

        if(filters_present) {
            setLocationFilters(["Tampa, FL", "San Clemente, CA"]);
        } else {

            setCurrentFilterData(prevfilters => {
                const filter_data = {};
                
                Object.keys(prevfilters).map((field) => {
                    filter_data[field] = [];
                    prevfilters[field].forEach((v) => {
                        filter_data[field].push({ ...v, isSelected: false })
                    });
                });
    
                //console.log("setting current filters srpExitFilters",filter_data);
    
                return filter_data;
    
            });

        }

        //setLocationFilters(["Tampa, FL", "San Clemente, CA"]);

        setCertifiedFilter(false);
    }

    useEffect(() => {
        console.log("fitler data changed");
    },[currentFilterData])

    // More Filter Modal

    const [openMoreModal, setOpenMoreModal] = useState(false);
    const handleFilterMoreModal = () => {
        setOpenMoreModal(true);
        document.body.classList.add('body-overflow');
    }
    const closeFilterMoreModal = () => {
        setOpenMoreModal(false)
        document.body.classList.remove('body-overflow');
    }



    const handlePriceSliderChange = (newValue) => {
        setPriceFilterData({ ...priceFilterData, ['current_min']: newValue[0], ['current_max']: newValue[1] });
    };

    const handleMileageSliderChange = (newValue) => {
        setMileageFilterData({ ...mileageFilterData, ['current_min']: newValue[0], ['current_max']: newValue[1] });
    };

    // For mobile View Condition

    const [isMobile, setIsMobile] = useState(false);
    const handleResize = () => {
        setIsMobile(window.innerWidth < 768);
    };

    useEffect(() => {
        const randomIndex = Math.floor(Math.random() * images.length);
        setBgImage(images[randomIndex]);

        handleResize();
        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
            console.log("clearing filters on srp exit",currentFilterData);
            srpExitFilters();
        };
    }, []);
    useEffect(() => {
        if (typeFilter && typeFilter.trim() !== "" && typeFilter.trim() !== "ALL") {
            const formattedLocation = typeFilter
                .replace(/-/g, " ")
                .replace(/\b\w/g, (l) => l.toUpperCase());

            setLocationFilters([formattedLocation]);
        } else if(typeFilter && typeFilter.trim() == "ALL") {
            // If typeFilter is empty → show ALL data
            //console.log("reseting location filters typeFilter");
            setLocationFilters(["Tampa, FL", "San Clemente, CA"]);
            // OR setLocationFilters([]) → if empty means no filter
        }

        setCertifiedFilter(certified ? true : false);
    }, [typeFilter, certified]);


    // const [sortSelectValue, setSortSelectValue] = useState('price');
    // const [sortOrder, setSortOrder] = useState(1);
    // const handleSortByChange = (e) => {
    //     const sort_val = e.target.value;
    //     setSortSelectValue(sort_val);
    //     setSortOrder(sort_val.includes("_low") ? -1 : 1);
    //     setSortColumn(sort_val.replace("_low", ""));
    // };
    const [sortBy, setSortBy] = useState("make_az");
    const sortedVehicleData = useMemo(() => {
        if (!filteredVehicleData) return [];

        let data = [...filteredVehicleData];

        switch (sortBy) {
            case "make_az":
                return data.sort((a, b) =>
                    a.make.localeCompare(b.make)
                );

            case "newest":
                return data.sort(
                    (a, b) =>
                        new Date(b.utc_inventory_date) -
                        new Date(a.utc_inventory_date)
                );

            case "price_high":
                return data.sort((a, b) => b.price - a.price);

            case "price_low":
                return data.sort((a, b) => a.price - b.price);

            case "mileage_high":
                return data.sort((a, b) => b.mileage - a.mileage);

            case "mileage_low":
                return data.sort((a, b) => a.mileage - b.mileage);

            default:
                return data;
        }
    }, [filteredVehicleData, sortBy]);


    const handleSortByChange = (e) => {
        setSortBy(e.target.value);
    };

    return (
        <>
            <SeoMeta
                title="Used Exotic Cars for Sale In Tampa, FL and San Clemente, CA | EEC"
                description="Explore an extraordinary selection of used exotic cars at European Exotic Center Tampa, FL and San Clemente, CA. From Bentley to Lamborghini, find your perfect fit today!"
                keywords=""
                ogTitle="Used Exotic Cars for Sale In Tampa, FL and San Clemente, CA | EEC"
                ogDescription="Explore an extraordinary selection of used exotic cars at European Exotic Center Tampa, FL and San Clemente, CA. From Bentley to Lamborghini, find your perfect fit today!"
            />
            <section className='srp-wrap'
                style={{
                    background: `#000 url(${bgImage}) no-repeat center top`,
                }}
            >
                <div className='srp-top-block'>
                    <div className='container'>
                        <div className='d-flex justify-content-between w-100 mb-md-0 mb-2'>
                            <div className='d-flex justify-content-between collection-header w-100 mb-md-5'>
                                <h1 className='lg-title font-2-5em fw-bold text-uppercase'>Our Collection</h1>
                                <div className='text-end d-md-block d-none'>
                                    <div className='xs-title text-uppercase mb-3 d-lg-block d-none'><img className='me-1 loc-icon' src={getImages('sm-locaton-icon.png')} /> Locations</div>
                                    <div className='d-flex align-items-center'>
                                        <div className="custom-checkbox location-checkbox me-5 pe-3">
                                            <input
                                                type="checkbox"
                                                name="location"
                                                value="Tampa, FL"
                                                id='location11'
                                                checked={locationFilters.includes("Tampa, FL")}
                                                onChange={(e) => {
                                                    if (e.target.checked) {
                                                        setLocationFilters([...locationFilters, "Tampa, FL"]);
                                                    } else {
                                                        setLocationFilters(locationFilters.filter(location => location !== "Tampa, FL"));
                                                    }
                                                }}
                                            />
                                            <label htmlFor="location11" className='w-100'>Tampa, FL</label>
                                        </div>
                                        <div className="custom-checkbox location-checkbox">
                                            <input
                                                type="checkbox"
                                                name="location"
                                                value="San Clemente, CA"
                                                id='location12'
                                                checked={locationFilters.includes("San Clemente, CA")}
                                                // checked={true}
                                                onChange={(e) => {
                                                    if (e.target.checked) {
                                                        setLocationFilters([...locationFilters, "San Clemente, CA"]);
                                                    } else {
                                                        setLocationFilters(locationFilters.filter(location => location !== "San Clemente, CA"));
                                                    }
                                                }}
                                            />
                                            <label htmlFor="location12" className='w-100'>San Clemente, CA</label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='d-lg-none d-block justify-content-between mb-3 srpt-title'>
                                <button type="button" className="filter-btn" onClick={handleMobFilterBtn}>
                                    <img alt="icon" className='me-3' src={getImages('filter-icon.png')} />
                                    Filters
                                </button>
                            </div>
                        </div>
                        <div className='d-md-none d-flex align-items-center mb-3'>
                            <div className='d-flex align-items-center'>
                                <div className="custom-checkbox location-checkbox me-5 pe-3">
                                    <input
                                        type="checkbox"
                                        name="location"
                                        value="Tampa, FL"
                                        id='location11'
                                        checked={locationFilters.includes("Tampa, FL")}
                                        onChange={(e) => {
                                            if (e.target.checked) {
                                                setLocationFilters([...locationFilters, "Tampa, FL"]);
                                            } else {
                                                setLocationFilters(locationFilters.filter(location => location !== "Tampa, FL"));
                                            }
                                        }}
                                    />
                                    <label htmlFor="location11" className='w-100'>Tampa, FL</label>
                                </div>
                                <div className="custom-checkbox location-checkbox">
                                    <input
                                        type="checkbox"
                                        name="location"
                                        value="San Clemente, CA"
                                        id='location12'
                                        checked={locationFilters.includes("San Clemente, CA")}
                                        // checked={true}
                                        onChange={(e) => {
                                            if (e.target.checked) {
                                                setLocationFilters([...locationFilters, "San Clemente, CA"]);
                                            } else {
                                                setLocationFilters(locationFilters.filter(location => location !== "San Clemente, CA"));
                                            }
                                        }}
                                    />
                                    <label htmlFor="location12" className='w-100'>San Clemente, CA</label>
                                </div>
                            </div>
                        </div>
                        <div className='d-lg-flex d-block align-items-center justify-content-between search-flex mb-3'>
                            <div className='d-flex search-box'>
                                <input type='text' className='form-control'
                                    placeholder='Search'
                                    value={searchText}
                                    onChange={(e) => { searchInputChanged(e.target.value) }}
                                />
                                <button className='search-btn'><span className='search-icon'></span></button>
                            </div>
                            <div className={`d-lg-inline-flex align-items-start srp-filter-block ${filerOptionsOpen ? '' : 'd-none'}`}>
                                <div className='srp-filter-header d-lg-none'>
                                    <div>Filters</div>
                                    <button className='sf-close-icon' onClick={closeSrpFilter} type='button'><img src={getImages('cross_icon.svg')} /></button>
                                </div>
                                <div className='srp-filter-body d-inline-flex gap-lg-3 gap-2'>
                                    <div className='d-lg-none mb-2'>
                                        <div className='sm-title text-start mb-1'>Applied Filters</div>
                                        <div className='d-flex align-items-center fl-tags'>
                                            <div className='fl-tag'><span>2022-2023</span> <button type='button' className='close-icon'></button></div>
                                            <div className='fl-tag'><span>1k-20k</span> <button type='button' className='close-icon'></button></div>
                                        </div>
                                    </div>
                                    <button type='button' className='fl-btn' onClick={() => handleFilterModal('year')}>
                                        <img src={getImages('year-icon.png')} />
                                        <span>Year</span>
                                    </button>
                                    <button type='button' className='fl-btn' onClick={() => handleFilterModal('make')}>
                                        <img src={getImages('make-icon.png')} />
                                        <span>Make</span>
                                    </button>
                                    <button type='button' className='fl-btn' onClick={() => handleFilterModal('model')}>
                                        <img src={getImages('model-icon.png')} />
                                        <span>Model</span>
                                    </button>
                                    <button type='button' className='fl-btn' onClick={() => handleFilterModal('trim')}>
                                        <img src={getImages('trim-icon.png')} />
                                        <span>Trim</span>
                                    </button>
                                    <button type='button' className='fl-btn' onClick={handleFilterMoreModal}>
                                        <img src={getImages('more-icon.png')} />
                                        <span>More</span>
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div className='selected-block d-md-flex align-items-center mb-1'>
                            <div className='d-md-flex d-none'>
                                <div className='fl-items-count me-4'>{filteredVehicleData ? filteredVehicleData.length : ""} Results</div>
                                <div className='d-flex align-items-center fl-tags'>
                                    {locationFilters.map((item, index) =>
                                        <div className='fl-tag' key={index}>
                                            <span className='filter-modal-title'>{item}</span>
                                            <button type='button' className='close-icon' onClick={() => {
                                                clearFilter(item);
                                                setLocationFilters(locationFilters.filter((location) => location !== item));
                                            }}></button>
                                        </div>
                                    )}
                                    {(priceFilterData.current_min > priceFilterData.min || priceFilterData.current_max < priceFilterData.max) &&
                                        <div className='fl-tag'>
                                            Price {priceFilterData.current_min == priceFilterData.min ? "Min" : numberFormatter(priceFilterData.current_min, true)} - {priceFilterData.current_max == priceFilterData.max ? "Max" : numberFormatter(priceFilterData.current_max, true)}
                                            <button type='button' className='close-icon' onClick={() => { handlePriceSliderChange([priceFilterData.min, priceFilterData.max]) }} />
                                        </div>}
                                    {(mileageFilterData.current_min > mileageFilterData.min || mileageFilterData.current_max < mileageFilterData.max) &&
                                        <div className='fl-tag'>
                                            Mileage {mileageFilterData.current_min == mileageFilterData.min ? "Min" : numberFormatter(mileageFilterData.current_min)} - {mileageFilterData.current_max == mileageFilterData.max ? "Max" : numberFormatter(mileageFilterData.current_max)}
                                            <button type='button' className='close-icon' onClick={() => { handleMileageSliderChange([mileageFilterData.min, mileageFilterData.max]) }} />
                                        </div>}
                                    {Object.keys(currentFilterData).map((key, i) => {
                                        return (
                                            currentFilterData[key].filter((item) => item.isSelected).map((item, j) => {
                                                return (
                                                    <div className='fl-tag' key={i + "-" + j}>
                                                        <span>{item.name}</span>
                                                        <button type='button' className='close-icon'
                                                            onClick={() => clearFilter(key)}
                                                        />
                                                    </div>
                                                );
                                            })
                                        )
                                    })}
                                    {certifiedFilter && <div className='fl-tag'>
                                        <span className='filter-modal-title'>Certified</span>
                                        <button type='button' className='close-icon' onClick={() => {
                                            setCertifiedFilter(false);
                                        }}></button>
                                    </div>}
                                </div>
                            </div>
                            <div className='d-md-flex align-items-center ms-auto'>
                                <div className='xs-title avenir-next font-14 me-3 mb-md-0 mb-2'>Sort by</div>
                                <div>
                                    <select
                                        className="form-control sort-select-field"
                                        value={sortBy}
                                        onChange={handleSortByChange}
                                    >
                                        <option value="make_az">Make: A → Z</option>
                                        <option value="newest">Newest Inventory</option>
                                        <option value="price_high">Price: High → Low</option>
                                        <option value="price_low">Price: Low → High</option>
                                        <option value="mileage_high">Miles: High → Low</option>
                                        <option value="mileage_low">Miles: Low → High</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {filteredVehicleData &&
                    <InventoryList
                        filteredVehicleData={sortedVehicleData}
                        numberFormatter={numberFormatter}
                        priceFormatter={priceFormatter}
                        currentFilterData={currentFilterData}
                        locationFilters={locationFilters}
                    />
                }
            </section>
            {openFilterModal &&
                <ModalLayout open={openFilterModal} close={closeMakeModal} darkThemeCls='true' modalWidth={970}>
                    <SelectFilterModal close={closeMakeModal} filterData={filterData} updateFilter={updateFilter} activeFilter={activeFilter} />
                </ModalLayout>
            }
            {openMoreModal &&
                <ModalLayout open={openMoreModal} close={closeFilterMoreModal} darkThemeCls='true' cls="more-filter-modal" modalWidth={970}>
                    <MoreFilterModal
                        close={closeFilterMoreModal}
                        filterData={filterData}
                        setCurrentFilterData={setCurrentFilterData}
                        numberFormatter={numberFormatter}
                        handlePriceSliderChange={handlePriceSliderChange}
                        handleMileageSliderChange={handleMileageSliderChange}
                        priceFilterData={priceFilterData}
                        mileageFilterData={mileageFilterData}
                        isMobile={isMobile}
                        handleFilterModal={handleFilterModal}
                        filteredVehicleData={filteredVehicleData}
                        currentFilterData={currentFilterData}
                        clearAllFilters={clearAllFilters}
                        locationFilters={locationFilters}
                        setLocationFilters={setLocationFilters}
                        clearFilter={clearFilter}
                    />
                </ModalLayout>

            }
        </>
    )
}

export default Inventory